import React, { FC, Fragment, useState } from "react";
import { styled } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Activities from "./Activities";
import RecomendedPosts from "./RecomendedPosts";
import { CreatePostButton } from "components/CreatePost";
import { IconButton, Paper, Typography } from "@mui/material";
import { useSubscriptionModal } from "components/SubscriptionModal";
import { useAuthContext } from "context/AuthContext";
import HelmetWithNotificationCount from "components/HelmetWithNotificationCount";
import { PostsContainer } from "components/PostComponent";
import { HomeTourProvider } from "providers/GuidedTour/HomeTourProvider";
import { TourInit } from "pages/club/components/TourInit";
import { Tabs, Tab } from "@mui/material";
import { useIsFeatureVisibleQuery } from "api";
import { isDarkMode } from "utills";
import { useSearchParam } from "react-use"
import { useHistory, useLocation } from "react-router-dom";

export const reference = React.createRef<HTMLButtonElement>();

const Home: FC = () => {
  const history = useHistory();
  const { search } = useLocation();
  const tab = useSearchParam("tab");
  const { data } = useIsFeatureVisibleQuery({
    variables: { featureName: "focused_feed" },
  });
  const [value, setValue] = useState<string>(tab ?? "yours");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    const searchParams = new URLSearchParams(search)
    if (newValue === "focused") {
      searchParams.set("tab", newValue);
    } else {
      searchParams.delete("tab");
    }
    history.replace({ search: searchParams.toString() });
    setValue(newValue);
  };

  return (
    <React.Fragment>
      <HomeTourProvider>
        <TourInit />
        <HelmetWithNotificationCount title="StockEdge Social - An exclusive premium social platform for stock market traders and investors by StockEdge" />
        <PostsContainer>
          <CreatePostButton />
          <ViewOnlyPopup />
          {data?.isFeatureVisible ? (
            <Fragment>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="home tabs"
              >
                <CustomTab
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="11"
                      height="11"
                      viewBox="0 0 11 11"
                      fill="none"
                    >
                      <path
                        d="M1.80227 10.9822C2.78292 10.9822 3.57789 10.1872 3.57789 9.20653C3.57789 8.22588 2.78292 7.43091 1.80227 7.43091C0.821616 7.43091 0.0266418 8.22588 0.0266418 9.20653C0.0266418 10.1872 0.821616 10.9822 1.80227 10.9822Z"
                        fill="currentColor"
                      />
                      <path
                        d="M5.94835 10.1122C5.94835 10.6005 6.34786 11 6.83616 11C7.32446 11 7.72397 10.6005 7.72397 10.1122C7.72397 6.34786 4.66102 3.27603 0.887813 3.27603C0.399516 3.27603 0 3.67555 0 4.16384C0 4.65214 0.399516 5.05166 0.887813 5.05166C3.68442 5.05166 5.94835 7.32446 5.94835 10.1122Z"
                        fill="currentColor"
                      />
                      <path
                        d="M10.1211 11C10.6094 11 11.0089 10.6005 11.0089 10.1122C11.0089 4.53672 6.47216 0 0.896693 0C0.408396 0 0.00888062 0.399516 0.00888062 0.887813C0.00888062 1.37611 0.408396 1.77563 0.896693 1.77563C5.49556 1.77563 9.23326 5.51332 9.23326 10.1122C9.23326 10.6005 9.62389 11 10.1211 11Z"
                        fill="currentColor"
                      />
                    </svg>
                  }
                  iconPosition="end"
                  label="Your Feed"
                  id="home-tab-0"
                  aria-label="home-tabpanel-0"
                  value="yours"
                />
                <CustomTab
                  icon={
                    <svg
                      width="13"
                      height="13"
                      viewBox="0 0 13 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.45183 1.32228H2.7259C1.77273 1.32228 1 2.09496 1 3.04818V4.77411"
                        fill="currentColor"
                      />
                      <path
                        d="M4.45183 11.6777H2.7259C1.77273 11.6777 1 10.905 1 9.9518V8.22587"
                        fill="currentColor"
                      />
                      <path
                        d="M7.90364 1.32228H9.62957C10.5827 1.32228 11.3555 2.09496 11.3555 3.04818V4.77411"
                        fill="currentColor"
                      />
                      <path
                        d="M7.90364 11.6777H9.62957C10.5827 11.6777 11.3555 10.905 11.3555 9.95183V8.2259"
                        fill="currentColor"
                      />
                      <path
                        d="M6.17773 4.77408C7.13031 4.77408 7.90364 5.54746 7.90364 6.49999C7.90364 7.45252 7.13031 8.22589 6.17773 8.22589C5.22516 8.22589 4.45183 7.45252 4.45183 6.49999C4.45183 5.54746 5.22516 4.77408 6.17773 4.77408Z"
                        fill="currentColor"
                      />
                    </svg>
                  }
                  iconPosition="end"
                  label="Focused Feed"
                  id="home-tab-1"
                  aria-label="home-tabpanel-1"
                  value="focused"
                />
              </Tabs>
              <TabPanel value={value} index="yours">
                <Activities ref={reference} />
              </TabPanel>
              <TabPanel value={value} index="focused">
                <RecomendedPosts ref={reference} />
              </TabPanel>
            </Fragment>
          ) : (
            <Activities ref={reference} />
          )}
        </PostsContainer>
      </HomeTourProvider>
    </React.Fragment>
  );
};

export default Home;

const CustomTab = styled(Tab)(({ theme }) => ({
  flex: 1,
  minHeight: "40px",
  color: "#9F9F9F",
  fontFamily: "Trebuchet MS",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "700",
  lineHeight: "normal",
  backgroundColor: isDarkMode(theme) ? "#ffffff06" : "#F4F4F4",
  marginTop: "20px",
  "&.Mui-selected": {
    backgroundColor: isDarkMode(theme) ? "#35404a" : "#D6EBFF",
    color: "#1B6AC9",
  },
}));

interface TabPanelProps {
  children?: React.ReactNode;
  index: string;
  value: string;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`home-tabpanel-${index}`}
      aria-labelledby={`home-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
};

const ViewOnlyPopup = () => {
  const { handleOpenModal } = useSubscriptionModal();
  const { isViewOnly } = useAuthContext();
  if (isViewOnly)
    return (
      <Container>
        <Text>
          You are currently on view only mode -{" "}
          <span onClick={() => handleOpenModal(undefined)}>Subscribe</span>
        </Text>
        <IconButton>
          <CloseIcon />
        </IconButton>
      </Container>
    );
  return null;
};

const Container = styled(Paper)`
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  padding: 10px 10px 10px 10px;
  margin: 15px auto 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (min-width: 540px) {
    display: none;
  }
`;

const Text = styled(Typography)`
  span {
    cursor: pointer;
  }
`;
